import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface CancelShiftPageConfirmedData {
  finalScore: number;
}

export interface CancelShiftPageConfirmedHandlers {
  onContinue: () => void;
}

type CancelShiftPageConfirmationScreenProps = CancelShiftPageConfirmedData &
  CancelShiftPageConfirmedHandlers;

export function CancelShiftPageConfirmationScreen(
  props: CancelShiftPageConfirmationScreenProps
): JSX.Element {
  const { finalScore, onContinue } = props;

  return (
    <Stack sx={{ flex: 1 }}>
      <Stack flex={1} alignItems="center" spacing={8} sx={{ paddingTop: 12, paddingX: 8 }}>
        <Text
          variant="h2"
          color={(theme) => theme.palette.intent?.error.text}
          sx={{ textAlign: "center" }}
        >
          This shift has been cancelled
        </Text>
        <Stack alignItems="center" spacing={6}>
          <Text variant="body2" sx={(theme) => ({ color: theme.palette.grey[600] })}>
            Your new Clipboard Score
          </Text>
          <Text
            color={(theme) => theme.palette.text.primary}
            sx={{
              fontSize: "7.25rem",
              fontWeight: 300,
              lineHeight: "96px",
              letterSpacing: "-0.01em",
            }}
          >
            {finalScore}
          </Text>
        </Stack>
      </Stack>

      <DialogFooter orientation="vertical">
        <Button fullWidth variant="contained" size="large" onClick={onContinue}>
          Got it
        </Button>
      </DialogFooter>
    </Stack>
  );
}
